import styled from "@emotion/styled";
import { Table } from "antd";

export const AdviseesTable = styled(Table)`
  font-size: 24px !important;
  margin-top: ${(props) => props.theme.spacing.md};
`;
